import { createTheme } from "@mui/material";
import { MONO_THEME_DEFINITION } from "@designboticteam/react/theme";
import { PALETTE } from "./palette";

const muiTheme = createTheme(
	{
		shape: {
			borderRadius: 2,
		},
		typography: {
			h1: {
				fontSize: "2.5rem",
				fontWeight: 700,
				lineHeight: 1.2,
			},
			h2: {
				fontSize: "2rem",
				fontWeight: 700,
				lineHeight: 1.25,
			},
			h3: {
				fontSize: "1.75rem",
				fontWeight: 600,
				lineHeight: 1.3,
			},
			h4: {
				fontSize: "1.5rem",
				fontWeight: 600,
				lineHeight: 1.35,
			},
			h5: {
				fontSize: "1.25rem",
				fontWeight: 600,
				lineHeight: 1.4,
			},
			h6: {
				fontSize: "1rem",
				fontWeight: 600,
				lineHeight: 1.4,
			},
			subtitle1: {
				fontSize: "1rem",
				fontWeight: 500,
				lineHeight: 1.5,
			},
			subtitle2: {
				fontSize: "0.875rem",
				fontWeight: 600,
				lineHeight: 1.45,
			},
		},
		palette: {
			mono: {
				main: PALETTE.neutral.graphite,
				light: PALETTE.tones.graphite[50],
				dark: PALETTE.main.primary,
				contrastText: PALETTE.neutral.white,
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					root: ({ ownerState }) => ({
						...(ownerState.variant !== "contained" && {
							color: PALETTE.neutral.graphite,
						}),
					}),
				},
			},
			MuiToggleButton: {
				styleOverrides: {
					root: {
						color: PALETTE.neutral.graphite,
					},
				},
			},
			MuiTypography: {
				styleOverrides: {
					root: {
						color: PALETTE.neutral.graphite,
					},
					h6: {
						color: PALETTE.accent.graphite,
					},
				},
			},
		},
	},
	MONO_THEME_DEFINITION,
);

muiTheme.shadows[1] = "0px 2px 3px 0px rgba(0, 0, 0, 0.3)";

export { muiTheme };
